<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-toolbar>
          <v-icon color="blue">receipt</v-icon>
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Auditoría de Producto Dirigido</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="closeComponent"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-row no-gutters>
          <span class="subtitle-1">Log de Estados</span>
        </v-row>
        <v-row no-gutters>
          <v-data-table
            :headers="headers"
            :items="model.logEstadoProductoDirigido"
            :loading="loading"
            hide-default-footer
            dense>
            <template v-slot:no-data>
              <v-alert
                dense
                :value="true"
                color="grey lighten-3"
                icon="warning">
                No se encontraron datos
              </v-alert>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  {{
                    item.fecha | dateParse() | dateFormat("DD-MM-YYYY HH:mm")
                  }}
                </td>
                <td class="text-xs-left caption">
                  {{ item.estadoDescripcion }}
                </td>
                <td class="text-xs-left caption">{{ item.responsable }}</td>
                <td
                  colspan="2"
                  v-if="item.comentarios"
                  class="font-weight-light caption">
                  {{ item.comentarios }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>

        <v-row no-gutters>
          <span class="subtitle-1">&nbsp;</span>
        </v-row>

        <v-row no-gutters>
          <span class="subtitle-1 font-weight-black">Modificar Estado</span>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              v-model="model.productoAEntregar"
              label="Producto A Entregar"
              :disabled="
                !checkCanAccess('ap-puede-modificar-productoentregado')
              "></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-autocomplete
              v-model="model.modelo"
              :items="listModelos"
              :disabled="false"
              item-text="descripcion"
              item-value="id"
              label="Modelo"
              placeholder="Modelo"
              :menu-props="{ minWidth: '200' }"></v-autocomplete>
          </v-col>

          <v-col>
            <v-text-field
              v-model="model.imei"
              label="IMEI"
              :disabled="
                !checkCanAccess('ap-puede-modificar-productoentregado')
              "></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-autocomplete
              v-model="model.nuevoEstadoId"
              :items="listEstados"
              :disabled="true"
              item-text="descripcion"
              item-value="id"
              label="Cambiar a"
              placeholder="Próximo Estado"
              :menu-props="{ minWidth: '200' }"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              v-model="model.comentarios"
              label="Comentarios"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="closeComponent"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="save">Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    headers: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 140 },
      { text: "Estado", value: "estadoDescripcion" },
      { text: "Responsable", value: "responsable", width: 90 },
      { text: "Comentarios", value: "comentarios", width: 90 },
    ],
    listEstados: [],
    listModelos: [],
    model: {},
    estadoActualId: 0,
    camposCeluObligatorios: false,
  }),
  props: {
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    creditoId: {
      type: String,
      required: false,
    },
    Cancel: Function,
  },
  watch: {},
  computed: {
    ...mapGetters(["checkCanAccess", "user"]),
  },
  async created() {
    await this.loadEstados();
    await this.loadModelos();
    console.log(this.creditoId);

    if (this.creditoId) {
      this.loadDatos();
    }
  },
  methods: {
    ...mapMutations([
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get("tiposestadoproductodirigido"); // traigo todas
        this.listEstados = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadModelos() {
      this.loading = true;
      try {
        var result = await http.get("tipoModeloTelefono");
        this.listModelos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadDatos() {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/logproductodirigido?creditoId=" + this.creditoId,
        );

        this.model = result;
        this.model.estadoActualId =
          this.model.logEstadoProductoDirigido.length > 0
            ? Math.max.apply(
                null,
                this.model.logEstadoProductoDirigido.map((log) => log.estadoId),
              )
            : 0;
        this.model.nuevoEstadoId = this.model.estadoActualId
          ? this.model.estadoActualId + 1
          : 1;
        console.log(this.model);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;

      try {
        console.log(this.model);

        await http.put(
          "creditos/updateestadoproductodirigido",
          JSON.stringify(this.model),
        );
        this.alertSuccess("Los cambios han sido registrados");

        // recargo
        this.loadDatos();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async camposObligatorios() {
      this.camposCeluObligatorios.value = true;
    },
    closeComponent() {
      this.hideActiveSubTask();
      this.Cancel();
    },
  },
};
</script>
